export default __webpack_public_path__ + "static/media/renaulfluence.b4a135f4.png";